export default {
  splitProperty(prop) {
    return prop.split(".");
  },
  getObject(obj, childObj) {
    if (obj[childObj] === undefined) obj[childObj] = {};
    return obj[childObj];
  },
  setProperty(obj, prop, val) {
    const chain = this.splitProperty(prop);
    let tmp = obj;
    for (let i = 0; i < chain.length - 1; i++) tmp = this.getObject(tmp, chain[i]);

    tmp[chain[chain.length - 1]] = val;
  },
  getProperty(obj, prop) {
    const chain = this.splitProperty(prop);
    let tmp = JSON.parse(JSON.stringify(obj));
    for (let i = 0; i < chain.length - 1; i++) tmp = this.getObject(tmp, chain[i]);

    return tmp[chain[chain.length - 1]];
  }
};
